import { createContext, useCallback, useContext, useState } from 'react';

const TextEditorContext = createContext();

export function TextEditorProvider({ children }) {
  const [textEditorState, setTextEditorState] = useState({
    activeTextId: '',
    text: '',
    showFloatingInput: true,
  });

  const updateTextEditorState = useCallback((newState) => {
    setTextEditorState((prev) => ({ ...prev, ...newState }));
  }, []);

  return (
    <TextEditorContext.Provider
      value={{
        textEditorState,
        updateTextEditorState,
      }}
    >
      {children}
    </TextEditorContext.Provider>
  );
}

export function useTextEditorContext() {
  const context = useContext(TextEditorContext);
  if (!context) {
    throw new Error('useTextEditorContext must be used within a TextEditorProvider');
  }
  return context;
}
